module.exports = __webpack_public_path__ + "img/aire_a.768497f9.png";